import { useAppDispatch, useAppSelector } from '@app/model/store'
import React, { FC, useEffect, useState } from 'react'
import { TypeFilterByKeyListCheckboxes, TypeTag } from '@features/Restaurant/RestaurantFilters/model/types'
import s from './FilterIntegratedListTemplate.module.sass'
import { Checkbox } from '@shared/ui/Form/Single/Checkbox'
import { Text } from '@shared/ui/Typography/Text'
import { CheckboxOption } from '@shared/types/fields/fields'
import { setCheckedFilterItemAsync } from '@features/Restaurant/RestaurantFilters/model/thunks'
import Accordion from '@shared/ui/Accordion/Accordion'
import { Search } from '@shared/ui/Form/Build/Search'
import { getDefaultField } from '@shared/lib/fields/getDefaultField'

interface Props {
  typeFilter: TypeFilterByKeyListCheckboxes
}

const title = {
  establishment: 'Тип заведения',
  metro: 'Метро',
  kitchen: 'Кухня',
}

const getFilterList = (value, list) => {
  return !value.trim()
    ? []
    : list.filter((tag: TypeTag) => {
        const cityNameLowerCase = tag.name.toLowerCase()
        const valueLowerCase = value.toLowerCase()
        return cityNameLowerCase.includes(valueLowerCase)
      })
}

export const FilterIntegratedListTemplate: FC<Props> = ({ typeFilter }) => {
  const dispatch = useAppDispatch()
  const stateFilters = useAppSelector((store) => store.features.restaurant_filters)
  const { list, visible } = stateFilters.filters[typeFilter]

  const [searchField, setSearchField] = useState(
    getDefaultField('search', {
      settings: {
        placeholder: '',
      },
    }),
  )
  const [tagSearchList, setTagSearchList] = useState([])

  const useList = searchField.value ? tagSearchList : list

  useEffect(() => {
    handleSearchTag(searchField.value)
  }, [stateFilters.filters[typeFilter]])

  const handleSearchTag = (value) => {
    setTagSearchList(() => getFilterList(value, list))
  }

  const changeChecked = (option: CheckboxOption, checked) => {
    dispatch(
      setCheckedFilterItemAsync({
        filterType: typeFilter,
        itemId: Number(option.id),
        checked: checked,
      }),
    )
  }

  if (!visible) return

  return (
    <Accordion title={title[typeFilter]}>
      {list.length ? (
        <>
          <Search field={searchField} setField={setSearchField} handleChange={handleSearchTag} />
          <div className={s['wrapper-lists']}>
            <div className={s['list-wrapper']}>
              <div className={`${s['list-shadow']} ${s['list-shadow--top']}`}></div>
              <div className={s.list}>
                {useList.length ? (
                  useList.map((tag) => {
                    const option = {
                      id: tag.id,
                      name: tag.slug,
                      label: tag.name.replaceAll('кухня', ''),
                      disabled: tag.disabled,
                    }
                    return (
                      <Checkbox
                        key={`default-${tag.id}`}
                        option={option}
                        checked={tag.checked}
                        onChange={changeChecked}
                      />
                    )
                  })
                ) : (
                  <Text sizes={'M'}>Ничего не найдено</Text>
                )}
              </div>
              <div className={`${s['list-shadow']} ${s['list-shadow--bottom']}`}></div>
            </div>
          </div>
        </>
      ) : (
        <Text sizes={'M'}>Ничего не найдено</Text>
      )}
    </Accordion>
  )
}
